import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzTreeFlatDataSource, NzTreeFlattener,  } from 'ng-zorro-antd/tree-view';
import { TreeNode } from '../../models/api-service-delegate';
import { FlatNode } from '../../models/api-service-delegate';
import { FlatTreeControl } from '@angular/cdk/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { NzSegmentedOptions } from 'ng-zorro-antd/segmented';
import { ClientViewModel } from '../../models-views/client.view.model';
import { QuickAddService } from '../../services/quick-add.service';
import { TaskViewModel } from '../../models-views/task.view.model';
import { Router } from '@angular/router';
import { ConsoleViewModel } from '../../models-views/console.view.modal';
import { Subject, takeUntil } from 'rxjs';
 
import { ConsoleTabService } from '../../services/console-tab.service';

@Component({
  selector: 'app-console-project-detail',
  standalone: false,
  templateUrl: './console-project-detail.component.html',
  styleUrl: './console-project-detail.component.scss'
})
export class ConsoleProjectDetailComponent {

  page:number = 1;
  page_size:number = 300;
  @Input() isVisible = false;
  @Input() tabData :any;
  @Input() type :any;
  @Output() closeModal = new EventEmitter<void>();
  userlist:any = []
  selectedTab: string = 'overview';
  private destroy$ = new Subject<boolean>();
  isConsolePage: boolean = false;
  sideMenus = [
    { id: 1, value: 'overview', label: 'Overviews', icon: 'info-circle'},
    { id: 2, value: 'tasks', label: 'Tasks', icon: 'reconciliation'},
    { id: 3, value: 'people', label: 'People', icon: 'user'},
    { id: 4, value: 'events', label: 'Events', icon: 'calendar'},
    { id: 5, value: 'files', label: 'Files', icon: 'folder-open'},
    { id: 6, value: 'drive_links', label: 'Links', icon: 'link'},
    { id: 7, value: 'history', label: 'History', icon: 'history'},
  ]
  @Output() openTaskDetailEventOnDetail = new EventEmitter<any>();

  constructor(private router: Router, private vm:ClientViewModel, private quickAddService:QuickAddService,
    private consoleTab: ConsoleTabService,  private vmt : TaskViewModel,private cvm : ConsoleViewModel) {

    this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(e=>{if(e === true){
      if(this.type == 'project'){
        this.cvm.getProjectById(this.tabData?.id);
      }
      if(this.type == 'task'){
        this.cvm.getTaskById(this.tabData?.id);
      }
    }})

    this.cvm.projectData.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.tabData = data
    })
    this.cvm.taskData.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.tabData = data
    })
    
    this.vm.userList.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.userlist = data.results
    })
  //  console.log(this.tabData)
  }

  ngOnInit(): void {
    this.vm.getUserList(this.page,this.page_size);
    if (this.router.url.includes('/app/console')) {
      this.isConsolePage = true;
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  
  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.closeModal.emit();
  }


  redirectToConsole(item: any, tabType: 'client' | 'project' | 'task' | 'event') {
    this.consoleTab.setConsoleTab(item, tabType);
    this.handleCancel();
    // if (!this.currentUrl.startsWith('/app/console')) {
      // this.router.navigateByUrl('/app/console');
    // }
  }
  
  formatIdToFourDigits(id: number, str: string): string {
    return id ? str+ id.toString().padStart(4, '0') : '';
  }


  getNameById(id:number){
    return id ? this.userlist.filter(e => e.id == id)[0].name : ''
  }

  
  editTask(data:any){
    // this.handleCancel()
    this.quickAddService.openQuickUpdate('task', data);
  }

  deleteTask(data:any){
    this.vmt.deleteTaskById(data.id)
   setTimeout(() => {
    this.handleCancel()
   },500 ) 
  }


  
  
  // getStatusColor(status: number): string {
     
  //   return status ?  this.listOfTaskStatus.filter( e => e.id == status)[0].hexcolor : 'default';
  // }
 

  // getTaskPriorityName(id:number){
  //   return this.listOfPriority.filter(e => e.id == id )[0].name
  //  }

  editProject(data:any){
    this.quickAddService.openQuickUpdate('project', data)
  }
  
  openTaskDetail(task: any){
    this.openTaskDetailEventOnDetail.emit(task);
  }
  
  onLinksChanged(event: any){
    if(event == true){
      this.quickAddService.refreshData.next(true);
    }
  }
  
  onFilesChanged(event: any){
    if(event == true){
      this.quickAddService.refreshData.next(true);
    }
  }


}
